import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import Zoom from 'react-reveal/Zoom'

import useStyles from './styles'
import { FaPlay } from 'react-icons/fa'

const List = ({ items }) => {
  const { list, item, itemText, icon, iconWrapper, itemTitle } = useStyles()

  return (
    <Zoom cascade>
      <div className={list}>
        {items.map((e, i) => (
          <Grid key={i} container className={item}>
            <Grid item container className={iconWrapper}>
              <Grid item xs={1}>
                <FaPlay className={icon} />
              </Grid>
              <Grid item xs={11}>
                <Typography className={itemTitle} component="span">
                  {e.title}
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography className={itemText}>{e.text}</Typography>
            </Grid>
          </Grid>
        ))}
      </div>
    </Zoom>
  )
}

export default List
